<template>
  <div class="umx-sidebar none" sidebar="0">
    <ul>
      <li
        class="sidebar-item umx-font-600 active"
        data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|088|001',button_name:'新设计'}}"
      >
        新设计
      </li>
      <li
        class="sidebar-item umx-font-600"
        data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|088|001',button_name:'更流畅'}}"
      >
        更流畅
      </li>
      <li
        class="sidebar-item umx-font-600"
        data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|088|001',button_name:'更低耗'}}"
      >
        更低耗
      </li>
      <li
        class="sidebar-item umx-font-600"
        data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|088|001',button_name:' 更有AI'}}"
      >
        更有AI
      </li>
      <li
        class="sidebar-item umx-font-600"
        data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|088|001',button_name:'跨生态'}}"
      >
        跨生态
      </li>
      <li
        class="sidebar-item umx-font-600"
        data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|088|001',button_name:'更护眼'}}"
      >
        更护眼
      </li> 
      <li
        class="sidebar-item umx-font-600"
        data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|088|001',button_name:'无障碍'}}"
      >
        无障碍
      </li>
      <li
        class="sidebar-item umx-font-600"
        data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|088|001',button_name:'更安全'}}"
      >
        更安全
      </li>
      <li
        class="sidebar-item umx-font-600"
        data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|088|001',button_name:'更多精彩'}}"
      >
        更多精彩
      </li>
      <li
        class="sidebar-item umx-font-600"
        data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|088|001',button_name:'适配计划'}}"
      >
        适配计划
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Navigator",
  methods: {},
};
</script>
<style lang="scss" scoped>
.umx-sidebar {
  position: fixed;
  top: 50%;
  left: 48px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  height: 480px;
  overflow: hidden;
  z-index: 100;
  -webkit-transition: opacity .5s ease;
  -o-transition: opacity .5s ease;
  -moz-transition: opacity .5s ease;
  transition: opacity .5s ease;
  // mix-blend-mode: difference;
  font-family: "vivoSansSCVF500";
}

.umx-sidebar::before, .umx-sidebar::after {
  content: '';
  position: absolute;
  left: 0;
  width: 2px;
}

.umx-sidebar::before {
  top: 0;
  height: 480px;
  background-color: #fff;
  opacity: 0.2;
}

.umx-sidebar::after {
  height: 48px;
  background-color: #fff;
  -webkit-transition: top .5s ease;
  -o-transition: top .5s ease;
  -moz-transition: top .5s ease;
  transition: top .5s ease;
}

.umx-sidebar[sidebar="0"]::after {
  top: 0;
}

.umx-sidebar[sidebar="1"]::after {
  top: 48px;
}

.umx-sidebar[sidebar="2"]::after {
  top: 96px;
}

.umx-sidebar[sidebar="3"]::after {
  top: 144px;
}

.umx-sidebar[sidebar="4"]::after {
  top: 192px;
}

.umx-sidebar[sidebar="5"]::after {
  top: 240px;
}

.umx-sidebar[sidebar="6"]::after {
  top: 288px;
}

.umx-sidebar[sidebar="7"]::after {
  top: 336px;
}

.umx-sidebar[sidebar="8"]::after {
  top: 384px;
}

.umx-sidebar[sidebar="9"]::after {
  top: 432px;
}

.umx-sidebar li {
  padding-left: 16px;
  font-size: 12px;
  line-height: 48px;
  color: #fff;
  opacity: 0.4;
  text-align: start;
  cursor: pointer;
  -webkit-transition: opacity .3s ease;
  -o-transition: opacity .3s ease;
  -moz-transition: opacity .3s ease;
  transition: opacity .3s ease;
}

.umx-sidebar li.active {
  opacity: 1;
}

.umx-sidebar.black::before, .umx-sidebar.black::after {
  background-color: #000;
}

.umx-sidebar.black li {
  color: #000;
}

.umx-sidebar.none {
  // z-index: -1;
  opacity: 0;
  pointer-events: none;
}
.isMobile,.isPad {
  .umx-sidebar {
    display: none;
  }
}
</style>